module.exports = __webpack_public_path__ + "img/grandma.90091e29.jpg";